// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XesgWa_a7Hgf7mxjrbvM{max-height:100%;z-index:var(--zIndex-OVERLAY_MAIN_1);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.XesgWa_a7Hgf7mxjrbvM.gux9UnMy5Zk7cJ8WSOya,.XesgWa_a7Hgf7mxjrbvM video{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XesgWa_a7Hgf7mxjrbvM`,
	"isFull": `gux9UnMy5Zk7cJ8WSOya`
};
export default ___CSS_LOADER_EXPORT___;
